import { COMPANY_USER_ROLES, imageUrlSchema } from '@crm/shared';
import { z } from 'zod';

const base = {
  name: z.string().min(2, 'Informe o nome completo').max(80),
  role: z.enum(COMPANY_USER_ROLES),
  isActive: z.boolean(),
  /** Os perfis de acesso do usuario - e daqui que vem toda a permissao dele. */
  profileIds: z.array(z.string()),
  /** Os mesmos dados pessoais do perfil, vistos pelo administrador. */
  image: imageUrlSchema,
  phone: z.string().trim().max(40),
  gender: z.enum(['', 'FEMALE', 'MALE', 'UNDISCLOSED']),
  instagram: z.string().trim().max(120),
  facebook: z.string().trim().max(120),
  x: z.string().trim().max(120),
};

export const createUserFormSchema = z.object({
  ...base,
  email: z.string().min(1, 'Informe o e-mail').email('E-mail invalido'),
  password: z.string().min(8, 'A senha deve ter no minimo 8 caracteres').max(128),
});

export const editUserFormSchema = z.object(base);

export type CreateUserFormValues = z.infer<typeof createUserFormSchema>;
export type EditUserFormValues = z.infer<typeof editUserFormSchema>;
